import { useMeeting } from '../../contexts/MeetingContext'
import useDraggable from '../../hooks/useDraggable'

function fmtTime(s: number): string {
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`
  return `${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`
}

export default function MeetingBar() {
  const { meeting, seconds, toFullscreen, endMeeting } = useMeeting()
  const { pos, onPointerDown, wasDrag } = useDraggable(null as { x: number; y: number } | null)

  if (!meeting) return null

  // Se pos é null = posição default CSS (centered bottom). Se arrastou, posição absoluta.
  const positioned = pos !== null

  return (
    <div
      className={`fixed z-[250] flex items-center gap-3 touch-none ${!positioned ? 'max-sm:bottom-24 max-sm:max-w-[calc(100vw-80px)] bottom-6' : ''}`}
      style={{
        ...(positioned
          ? { left: pos.x, top: pos.y }
          : { left: '50%', transform: 'translateX(-50%)' }),
        padding: '8px 8px 8px 16px',
        borderRadius: 100,
        background: 'rgba(12, 12, 12, 0.72)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid rgba(255,255,255,0.10)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)',
        whiteSpace: 'nowrap',
        cursor: 'grab',
      }}
      onPointerDown={onPointerDown}
      onClick={() => { if (!wasDrag.current) toFullscreen() }}
    >
      {/* Indicador ao vivo */}
      <div className="flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full animate-pulse shrink-0"
          style={{ background: 'var(--color-hero)' }} />
        <span className="text-[9px] tracking-[0.10em] uppercase font-bold"
          style={{ color: 'var(--color-hero)' }}>
          Ao Vivo
        </span>
      </div>

      {/* Separador */}
      <span style={{ width: 1, height: 12, background: 'rgba(255,255,255,0.10)', display: 'block' }} />

      {/* Título */}
      <span className="text-[12px] text-[#bbb] max-w-[180px] truncate">
        {meeting.reuniao.titulo}
      </span>

      {/* Timer */}
      <span className="text-[13px] font-light text-[#f0f0f0] [font-variant-numeric:tabular-nums]">
        {fmtTime(seconds)}
      </span>

      {/* Separador */}
      <span style={{ width: 1, height: 12, background: 'rgba(255,255,255,0.10)', display: 'block' }} />

      {/* Botões */}
      <button
        onClick={e => { e.stopPropagation(); toFullscreen() }}
        className="flex items-center gap-1 px-3 py-1.5 rounded-full text-[10px] text-[#888] hover:text-[#f0f0f0] transition-colors cursor-pointer border-none bg-transparent"
        title="Abrir" aria-label="Abrir reunião"
      >
        <span className="material-symbols-outlined text-[13px]">open_in_full</span>
      </button>

      <button
        onClick={e => { e.stopPropagation(); toFullscreen() }}
        className="px-3 py-1.5 rounded-full text-[10px] font-semibold uppercase tracking-[0.06em] cursor-pointer border-none transition-colors"
        style={{ background: 'rgba(217,48,37,0.20)', color: 'var(--color-vermelho)' }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(217,48,37,0.35)' }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(217,48,37,0.20)' }}
      >
        Encerrar
      </button>
    </div>
  )
}
